import { logger } from '../lib/logging'
import { BASE_URL } from '../config'
import loSto from '../config/loSto'

const fetchFhirConfig = () => {
  logger.info('Fetching FHIR config')
  const url = BASE_URL.replace('api', 'web-api-v2') + '/fhir/config/web'
  return fetch(url, {
    method: 'GET',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      authorization: loSto.get('okta-token-storage')?.idToken?.value
    }
  })
    .then((response) => {
      logger.info('Succesfully fetched FHIR config', response)
      return response.json()
    })
    .catch((error) => {
      logger.error('Failed to fetch FHIR config', error)
      return {
        error
      }
    })
}

export { fetchFhirConfig }
